import React from 'react';
import { white } from '../../Styles/Colours';
import { Button } from '../Button';
import { LoadingErrorIcon, ReloadIcon } from '../Icons';
import styles from './LoadingError.module.scss';

export function LoadingError({ message, info }: { message?: string; info?: React.ReactNode }): React.ReactElement {
    const reload = () => {
        window.location.reload();
    };

    return (
        <div className={styles.container}>
            <LoadingErrorIcon />
            <div className={styles.bodyText}>{message ?? 'Whoops... we’ve run into an error'}</div>
            <div className={styles.info}>{info ?? 'Please reload the page to try fetch the data you need.'}</div>
            <Button
                testId='error-action'
                onClick={reload}
                startIcon={<ReloadIcon color={white} size={'24'} noPadding />}
            >
                Reload
            </Button>
        </div>
    );
}
